module.exports = __webpack_public_path__ + "img/warzone.0bd77f79.png";